<template>
    <div class="title-box">
        <div class="title">
            <img class="title-left-icon" :src="'../static/img/' + type + '-left-icon.png'" alt="">
            <div class="middle-text" :style="type == 'white' ? 'color: #fff' : ''">{{english}}</div>
            <img class="title-right-icon" :src="'../static/img/' + type + '-right-icon.png'" alt="">
            <div class="title-position" :style="type == 'white' ? 'color: #fff' : ''">{{title}}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'title-modules',
    props: {
        title: {
            type: String,
            value: ''
        },
        english: {
            type: String,
            value: ''
        },
        type: {
            type: String,
            value: 'blue'
        }
    },
    mounted(){
        this.handleScroll()
    },
    methods: {
        handleScroll(){
            const images = document.querySelectorAll("img");
            // 传给IntersectionObserver的回调函数
            // 在目标元素能看见时触发一次，目标元素看不见了时再触发一次
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const image = entry.target;
                        const data_src = image.getAttribute("data-src");
                        image.setAttribute("src", data_src);
                        console.log('触发')
                        // 图片被加载后取消观察
                        observer.unobserve(image);
                    }
                });
            });
            images.forEach(image => {
                observer.observe(image);
            });
        }
    }
}
</script>
<style scoped>
@media only screen and (max-width: 1480px){
.title-box{
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 106px auto 65px;
}
.title{
    height: 31px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}
.title-left-icon,.title-right-icon{
    width: 70px;
}
.middle-text{
    font-size: 40px;
    text-align: center;
    font-family: Arial;
    font-weight: bold;
    color: #4468E6;
    opacity: 0.25;
    padding: 0 40px;
    white-space: nowrap;
}
.title-position{
    position: absolute;
    font-size: 27px;
    color: #2B2E48;
    top: -18px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
}
}
@media only screen and (min-width: 1480px){
.title-box{
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 150px auto 80px;
}
.title{
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}
.title-left-icon,.title-right-icon{
    width: 100px;
}
.middle-text{
    font-size: 56px;
    text-align: center;
    font-family: Arial;
    font-weight: bold;
    color: #4468E6;
    opacity: 0.25;
    padding: 0 50px;
    white-space: nowrap;
}
.title-position{
    position: absolute;
    font-size: 38px;
    color: #2B2E48;
    top: -22px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
}
}
</style>


// WEBPACK FOOTER //
// src/components/Title-modules.vue